import React from 'react'
import Page from 'component/page-container'
import { NavLink, useParams } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/ru'

import './style.css'

/* global API */

const EventListRoute = () => {
    const [ eventList, setEventList ] = React.useState([])
    const { processId = 0 } = useParams()

    // Event List
    React.useEffect(() => {
        API.instance().getEventList().then(eventList => {
            setEventList(
                eventList.map(event => {
                    event.dateStartFormatted = moment(event.dateStart).format('ll')
                    return event
                }).filter(event => processId === 0 || parseInt(event.process.id, 10) === parseInt(processId, 10))
            )
        })
    }, [processId])

    return (
        <Page className="event-list-page" h1='События'>
            <div className="page__inner">
                {!!eventList.length ? (
                    <table className="event-list">
                        <thead>
                            <tr>
                                <td>Процесс</td>
                                <td>Событие</td>
                                <td>Дата</td>
                                <td>Организатор</td>
                            </tr>
                        </thead>
                        <tbody>
                            {eventList.map(event => (
                                <tr key={event.id} className="event-list__event">
                                    <td className="event-list__process">{event?.process?.title}</td>
                                    <td className="event-list__title"><NavLink exact to={'/events/' + event.id}>{event.title}</NavLink></td>
                                    <td className="event-list__date">{event.dateStartFormatted}</td>
                                    <td className="event-list__user">{event.user.name} {event.user.surname}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : 'Пустенько пока'}
            </div>
        </Page>
    )
}

export default EventListRoute
